// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"contextmenu-module--dropdownMenu--kDCWW"};